import { ReactComponent as DateIcon } from 'assets/icons/input_type_date.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/input_type_email.svg';
import { ReactComponent as NumberIcon } from 'assets/icons/input_type_number.svg';
import { ReactComponent as PasswordIcon } from 'assets/icons/input_type_password.svg';
import { ReactComponent as TextIcon } from 'assets/icons/input_type_text.svg';
import { ReactComponent as LabelAlignBottomIcon } from 'assets/icons/table_align_bottom.svg';
import { ReactComponent as LabelAlignMiddleIcon } from 'assets/icons/table_align_middle.svg';
import { ReactComponent as LabelAlignTopIcon } from 'assets/icons/table_align_top.svg';
import { HANDLE } from 'constants/bounding-box';
import { Widget } from 'types/widget.types';

import {
  FormType,
  FormWidgetData,
  InputType,
  LabelAlignment,
  SelectionFieldData,
  SelectionFieldLayoutType,
  SelectionFieldType,
} from './FormWidget.types';

export const BOUNDING_BOX_CONFIG = {
  customHandle: (widget: Widget) => {
    const widgetData = widget as FormWidgetData;
    if (widgetData.type === FormType.LongQuestion) {
      return HANDLE.SIDE_CORNERS;
    }
    return HANDLE.LEFT_RIGHT;
  },
  rotatable: false,
};

export const LABEL_ALIGNMENT_OPTIONS = [
  { value: LabelAlignment.start, label: 'top', icon: <LabelAlignTopIcon /> },
  { value: LabelAlignment.center, label: 'middle', icon: <LabelAlignMiddleIcon /> },
  { value: LabelAlignment.end, label: 'bottom', icon: <LabelAlignBottomIcon /> },
];

export const DEFAULT_FORM_FIELD_VALUE = {
  [InputType.Textarea]: {
    label: 'What improvements or suggestions do you have?',
    type: InputType.Textarea,
    value: '',
    placeholder: '',
  },
  [InputType.Text]: { label: 'Name', type: InputType.Text, value: '', placeholder: '' },
  [InputType.Email]: { label: 'Email', type: InputType.Email, value: '', placeholder: '' },
  [InputType.Password]: { label: 'Password', type: InputType.Password, value: '', placeholder: '' },
  [InputType.Date]: { label: 'Date', type: InputType.Date, value: '', placeholder: '' },
  [InputType.Number]: { label: 'Number', type: InputType.Number, value: '', placeholder: '' },
  [FormType.SelectionField]: {
    label: 'What aspect of service did you find most satisfactory?',
    type: InputType.Text,
    value: '',
    placeholder: '',
  },
};

export const INPUT_TYPE_OPTIONS = [
  {
    value: InputType.Text,
    label: 'text',
    icon: <TextIcon />,
  },
  {
    value: InputType.Email,
    label: 'email',
    icon: <EmailIcon />,
  },
  {
    value: InputType.Password,
    label: 'password',
    icon: <PasswordIcon />,
  },
  {
    value: InputType.Date,
    label: 'date',
    icon: <DateIcon />,
  },
  {
    value: InputType.Number,
    label: 'number',
    icon: <NumberIcon />,
  },
];

export const FORM_INPUT_TEST_ID = 'form-input-field';

export const MIN_WIDTH = 200;
export const MIN_HORIZONTAL_HEIGHT = 88;
export const MIN_VERTICAL_HEIGHT = 132;

export const DEFAULT_SHORT_TEXT_FIELD_WIDTH = 300;
export const DEFAULT_SHORT_TEXT_FIELD_HEIGHT = 76;
export const DEFAULT_LONG_TEXT_FIELD_WIDTH = 365;
export const DEFAULT_LONG_TEXT_FIELD_HEIGHT = 116;
export const DEFAULT_SELECTION_FIELD_WIDTH = 365;
export const DEFAULT_SELECTION_FIELD_HEIGHT = 172;

export const DEFAULT_TEXTAREA_HEIGHT = 80;

/**
 * Selection Field
 */
export const DEFAULT_SELECTION_FIELD_TYPE = SelectionFieldType.Radio;
export const DEFUALT_SELECTION_FIELD_LAYOUT = SelectionFieldLayoutType.Vertical;

export const DEFAULT_SELECTION_FIELD_OPTION_TEXT = 'Click to edit text';
export const DEFAULT_SELECTION_FIELD_DATA: SelectionFieldData = {
  type: DEFAULT_SELECTION_FIELD_TYPE,
  layout: DEFUALT_SELECTION_FIELD_LAYOUT,
  options: [
    { index: 0, value: 'Punctuality' },
    { index: 1, value: 'Quality of Service' },
    { index: 2, value: 'Professionalism' },
    { index: 3, value: 'Communication' },
  ],
  enableOther: false,
  enableMultipleSelection: false,
};

export const LIMIT_SELECTION_FIELD_OPTIONS = 10;
export const SELECTION_FIELD_INPUT_TEST_ID = 'form-input-field';
